import styles from './MobileGeographySection.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import ButtonLink from 'src/components/ButtonLink';
import RetinaImage from 'src/components/RetinaImage';
import { ScrollOverPack, TweenOne, FadeUp, FadeLeft } from 'src/components/Animations';

import ImgMobileShippingZones from 'src/images/img-mobile-shipping-zones.png';
import ImgMobileShippingZones2x from 'src/images/img-mobile-shipping-zones@2x.png';
import ImgMobileShippingZones3x from 'src/images/img-mobile-shipping-zones@3x.png';

export default (props) => (
  <div styleName='mobile-geography-section'>
      <ScrollOverPack component={Container} styleName='container'>
          <TweenOne key='text-container' styleName='text-container' {...FadeUp}>
              <div className='h2 text-blue'>
                  On the go?
              </div>
              <div className='h2'>
                  Take your data with you.
              </div>
              <div styleName='message'>
                  We know you can’t always be at your desk. That’s why Galleon is
                  optimized for mobile phones and tablets, too.
              </div>
              <ButtonLink styleName='button' to='/contact'>
                  Try free for 7 days
              </ButtonLink>
          </TweenOne>
          <TweenOne key='splash-image-container'
                    styleName='splash-image-container'
                    {...FadeLeft}>
              <RetinaImage srcSet={[ImgMobileShippingZones, ImgMobileShippingZones2x, ImgMobileShippingZones3x]}
                           styleName='splash-image' />
              <div styleName='touch-dot-1' />
              <div styleName='touch-dot-2' />
          </TweenOne>
      </ScrollOverPack>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/MobileGeographySection.js